import React, { useState, useEffect } from "react";
import styled from "styled-components";

const StyledSliderText = styled.h2`
  font-weight: normal;
  font-size: 20px;
  margin: 0px;
  padding: 0px 0px;
  text-align: center;
  line-height: 80px;
`;

const ImageSlider = ({ images = [] }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => {
      if (images.length === 0) return 0; // safeguard
      return prevIndex === images.length - 1 ? 0 : prevIndex + 1;
    });
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => {
      if (images.length === 0) return 0; // safeguard
      return prevIndex === 0 ? images.length - 1 : prevIndex - 1;
    });
  };

  useEffect(() => {
    if (images.length > 0) {
      const interval = setInterval(nextSlide, 5000);
      return () => clearInterval(interval);
    }
  }, [images]);

  if (images.length === 0) {
    return (
      <div style={styles.imageCon}>
        <p>No images available</p>
      </div>
    );
  }

  return (
    <div style={styles.imageCon}>
      <img
        src={images[currentIndex]?.image}
        alt={`Slide ${currentIndex}`}
        style={styles.image}
      />
      <StyledSliderText>Making your vision a Reality</StyledSliderText>
    </div>
  );
};

const styles = {
  imageCon: {
    height: "calc(100% - 80px)",
  },
  image: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "50px",
  },
};

export default ImageSlider;
